<template>
  <div>
    <qx-card title="客户" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100000"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  customerArchivesDetail, // 获取详情
} from 'api/archives';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      loading: false,
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'customerCode',
                label: '客户编码',
              },
              {
                prop: 'companyName',
                label: '客户全称',
              },
              {
                prop: 'lineName',
                label: '联系人',
              },
              {
                prop: 'linePhone',
                label: '联系手机',
              },
              {
                prop: 'orgName',
                label: '归属部门',
              },
              {
                prop: 'customerTypeName',
                label: '客户类型',
              },
              {
                prop: 'stateName',
                label: '客户状态',
              },
              {
                prop: 'address',
                label: '公司地址',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        settlement: {
          label: '结算信息',
          tableData: {
            title: [
              {
                prop: 'payWayName',
                label: '结算方式',
              },
              {
                prop: 'reciveTime',
                label: '回单期限',
              },
              {
                prop: 'collection',
                label: '收款期限',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/archives/customer/archives/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await customerArchivesDetail({
        customerId: this.id || this.$route.query.id,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        if (detailRes.code && detailRes.code === 202) {
          this.$message({
            type: 'warning',
            message: detailRes.msg,
          });
          this.close();
        } else {
          detailRes.ver.customerCode = detailRes.obj.customerCode;
          switch (String(detailRes.obj.payWay)) {
            case '1': // 预付全款
            case '2': // 预付 + 尾款账期
              detailRes.obj.reciveTime = `离场日期后${detailRes.obj.reciveTime}号`;
              if (detailRes.obj.collectionTime) {
                detailRes.obj.collection = `离场日期后${detailRes.obj.collectionTime}号`;
              }
              break;
            case '3': // 预付 + 尾款月结
              detailRes.obj.reciveTime = `${detailRes.obj.reciveMonth}个月后${detailRes.obj.reciveDay}号`;
              detailRes.obj.collection = `${detailRes.obj.collectionMonth}个月后${detailRes.obj.collectionDay}号`;
              break;
            default:
              break;
          }
          this.detailData.base.tableData.data = detailRes.obj;
          this.detailData.settlement.tableData.data = detailRes.obj;
          if (this.id || this.$route.query.type) {
            switch (String(detailRes.ver.payWay)) {
              case '1': // 预付全款
              case '2': // 预付 + 尾款账期
                detailRes.ver.reciveTime = `离场日期后${detailRes.ver.reciveTime}号`;
                if (detailRes.ver.collectionTime) {
                  detailRes.ver.collection = `离场日期后${detailRes.ver.collectionTime}号`;
                }
                break;
              case '3': // 预付 + 尾款月结
                detailRes.ver.reciveTime = `${detailRes.ver.reciveMonth}个月后${detailRes.obj.reciveDay}号`;
                detailRes.ver.collection = `${detailRes.ver.collectionMonth}个月后${detailRes.obj.collectionDay}号`;
                break;
              default:
                break;
            }
            this.detailData.base.tableData.approveData = detailRes.ver;
            this.detailData.settlement.tableData.approveData = detailRes.ver;
          }

        }
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
